import makeStyles from '@mui/styles/makeStyles';
import React from "react";
import i18next from "i18next";
import {Typography} from "@mui/material";
import {Trans} from "react-i18next";
import {getEnv} from "../../config/Config";
import RegistrationNotFoundBlock from "../../containers/RegistrationNotFoundBlock";

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: "#FFEBEB",
        width: "644px",
        marginTop: "20px",
        position: "relative",
        top: "25px",
        borderRadius: "16px",
        padding: "15px",
        display: "flex",
        justifyContent: "space-between",
        gap: "15px"
    },
    typoWrapper: {
        fontSize: "14px",
        color: "#990001",
        textAlign: "center"
    },
    typoWrapperAlreadyRegistered: {
        fontSize: "14px",
        color: "#CC7B00"
    },
    link: {
        fontSize: "14px",
        color: "#2E2E3A"
    }
}));


function ErrorNotice({errorType, registrationTheme, appUrl, app}) {
    const classes = useStyles();
    const [isOpen, setIsOpen] = React.useState(true);
    return isOpen && (
        <div className={classes.root} onClick={() => setIsOpen(false)}>
            <div>
                {errorType === "userAlreadyRegistered" &&
                <img
                    alt="icon"
                    src="../assets/warning.svg"
                />}
            </div>

            <div style={{flex: 1}}>
                {/* Erreur inconnue */}
                {errorType === "unknownError" && (
                    <Typography className={classes.typoWrapper}>
                        <Trans i18nKey="errors.ERROR_UNKNOWN">
                            {i18next.t('errors.ERROR_UNKNOWN')}
                            &nbsp;<a href={i18next.t('support.url')}>{i18next.t('here')}</a>.
                        </Trans>
                    </Typography>
                )}

                {/* Invitation expirée */}
                {errorType === "invalidRegistration" && (
                    <Typography className={classes.typoWrapper}>
                        {i18next.t('invalidRegistration1')}<br /><br />
                        {i18next.t('invalidRegistration2')}<br /><br />
                        {i18next.t('invalidRegistration3')} <a href={getEnv(`REACT_APP_URL_${app.toUpperCase()}`) || getEnv(`REACT_APP_URL_DO`)}>{i18next.t('here')}</a>.
                    </Typography>
                )}

                {/* Invitation annulée */}
                {errorType === "registrationNotFound" && (
                    <Typography className={classes.typoWrapper}>
                       <RegistrationNotFoundBlock app={app} appUrl={appUrl} />
                    </Typography>

                )}

                {/* Utilisateur déja enregistrer */}
                {errorType === "userAlreadyRegistered" && (
                    <Typography className={classes.typoWrapperAlreadyRegistered}>
                        <Trans i18nKey="userAlreadyRegistered" appUrl={appUrl}>
                            {i18next.t('userAlreadyRegistered1')}<br/>
                            {i18next.t('userAlreadyRegistered2')}
                            <a href={appUrl} className={classes.link}>{i18next.t('clickHere')}</a>.
                        </Trans>
                    </Typography>
                )}
            </div>

            <div>
                <img
                    // className="logo"
                    alt="icon"
                    src={errorType === "userAlreadyRegistered" ? "../assets/arrow_forward.svg" : "../assets/close.svg"}
                />
            </div>
        </div>
    );
}

export default ErrorNotice;
